var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPowerSettingsNew(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_387_9950",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.365234,
    y: 0.34375,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_387_9950)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8652 13.3453V4.19531H12.8652V13.3453H11.8652ZM12.3652 20.3453C11.2652 20.3453 10.2279 20.137 9.25323 19.7203C8.2779 19.3036 7.4279 18.733 6.70323 18.0083C5.9779 17.283 5.4069 16.4326 4.99023 15.4573C4.57357 14.4826 4.36523 13.4453 4.36523 12.3453C4.36523 11.1453 4.61957 10.016 5.12823 8.95731C5.63623 7.89931 6.34023 6.98698 7.24023 6.22031L7.94023 6.92031C7.12357 7.57031 6.49023 8.37031 6.04023 9.32031C5.59023 10.2703 5.36523 11.2786 5.36523 12.3453C5.36523 14.2786 6.04857 15.9286 7.41523 17.2953C8.7819 18.662 10.4319 19.3453 12.3652 19.3453C14.3152 19.3453 15.9692 18.662 17.3272 17.2953C18.6859 15.9286 19.3652 14.2786 19.3652 12.3453C19.3652 11.2786 19.1442 10.2703 18.7022 9.32031C18.2609 8.37031 17.6236 7.57031 16.7902 6.92031L17.4902 6.22031C18.3902 6.98698 19.0946 7.89931 19.6032 8.95731C20.1112 10.016 20.3652 11.1453 20.3652 12.3453C20.3652 13.4453 20.1569 14.4826 19.7402 15.4573C19.3236 16.4326 18.7529 17.283 18.0282 18.0083C17.3029 18.733 16.4569 19.3036 15.4902 19.7203C14.5236 20.137 13.4819 20.3453 12.3652 20.3453Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerSettingsNew);
export default __webpack_public_path__ + "static/media/power_settings_new.898d83a7a9982cd327063a71a93ed75c.svg";
export { ForwardRef as ReactComponent };